import { withChartLayout } from 'components/common';
import CarePlan from 'components/features/chart/care-plan/CarePlan';

const CarePlanPage = withChartLayout('Care Plan')(CarePlan);
export default CarePlanPage;
